import { aoProductListViewed } from '../tagular'

export default function handleProductListViewed(productBoxes) {
  // Build out products for tagular event.
  const products = productBoxes.map(product => {
    const position = product.getAttribute('data-tagular-index') || '0'
    return {
      brand: product.getAttribute('data-issuer-name') || '',
      category: 'Approval Odds',
      location: 'ApprovalOdds',
      name: product.getAttribute('data-beam-name') || '',
      position: Number(position),
      productId: product.getAttribute('data-product-id') || ''
    }
  })

  // Fire event.
  aoProductListViewed(products)
}
